import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import LanguageSelector from "../LanguageSelector";

const MobileNav = ({ isOpen, onClose, navLinks }) => {
  const { t } = useTranslation();

  const stats = [
    {
      icon: "/assets/calendar.svg",
      title: t('hero.stat1Title'),
      description: t('hero.stat1Description'),
    },
    {
      icon: "/assets/clock.svg",
      title: t('hero.stat2Title'),
      description: t('hero.stat2Description'),
    },
    {
      icon: "/assets/verified.svg",
      title: t('hero.stat3Title'),
      description: t('hero.stat3Description'),
    },
  ];

  return (
    <div
      className={`fixed inset-0 z-50 md:hidden transition-opacity duration-300 ${
        isOpen ? "opacity-100 visible" : "opacity-0 invisible"
      }`}
    >
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black transition-opacity duration-300 ${
          isOpen ? "opacity-50" : "opacity-0"
        }`}
        onClick={onClose}
      ></div>

      {/* Side Panel */}
      <div
        className={`absolute right-0 top-0 h-full w-full bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 bg-[#024F53] m-4 rounded-[12px]">
          <img
            src="/assets/logo.svg"
            alt="DentFinder"
            className="h-8 w-auto"
          />
          <div className="flex items-center gap-4">
            <LanguageSelector arrowColor="white" />
            <button
              onClick={onClose}
              className="p-1 text-white hover:opacity-80 transition-opacity"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Navigation Content */}
        <div className="flex flex-col h-[calc(100%-80px)] justify-between">
          {/* Navigation Links */}
          <nav className="flex flex-col py-6">
            {navLinks.map((link, index) => (
              <Link
                key={index}
                to={link.href}
                onClick={onClose}
                className="flex items-center justify-between px-6 py-5 text-base font-normal text-[#1F1F1F] hover:bg-gray-50 transition-colors border-b border-gray-100"
              >
                <span>{link.name}</span>
                <svg
                  width="8"
                  height="14"
                  viewBox="0 0 8 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 13L7 7L1 1"
                    stroke="#3A3A3A"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            ))}
          </nav>

          {/* Stats and CTA Section */}
          <div className="px-6 pb-14 space-y-6">
            {/* Stats Card */}
            <div className="border-[3px] border-[#016E751A] rounded-2xl p-6 space-y-4">
            <div className="space-y-4">
                  {stats.map((stat, index) => (
                    <div
                      key={index}
                      className={`flex items-start gap-x-2 border-b border-[#E1E1E1] pb-4 ${
                        index === stats.length - 1 ? "border-b-0" : ""
                      }`}
                    >
                      <img src={stat.icon} alt={stat.title} />
                      <p className="font-bold text-[#007B83] text-sm">
                        {stat.title}
                        <span className="text-sm text-[#00191ACC] font-normal">
                          {" "}
                          {stat.description}
                        </span>
                      </p>
                    </div>
                  ))}
                </div>
            </div>

            {/* CTA Button */}
            <Link
              to="/get-started"
              onClick={onClose}
              className="btn-primary w-full text-center block"
            >
              {t('mobileNav.getStarted')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileNav;

